import React, { useState, useEffect } from 'react';

// Images
import avatar from "../../assets/images/users/avatar-1.jpg";
import { Alert, Avatar, Box, Button, Grid, InputLabel, TextField, Typography } from '@mui/material';


// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

// actions
import { editProfile, resetProfileFlag } from "../../slices/thunk";
import { createSelector } from "reselect";
import { useTheme } from '@emotion/react';
import useStyles, { Colortheme } from '../comman';

const UserProfile = () => {

    document.title = "User Profile | Rudrix";
    const theme: any = useTheme();
    const dispatch: any = useDispatch();

    const [email, setemail] = useState<string>("admin@gmail.com");
    const [uid, setuid] = useState<number>(1);

    const [userName, setUserName] = useState<string>("Admin");

    const selectLayoutState = (state: any) => state.Profile;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        (UserProfile) => ({
            success: UserProfile.success,
            error: UserProfile.error
        })
    );


    // Inside your component
    const { success,error } = useSelector(selectLayoutProperties);


    useEffect(() => {
        if (localStorage.getItem("authUser")) {
            if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
                const obj = JSON.parse(localStorage.getItem("authUser") || "");
                setUserName(obj.displayName);
                setemail(obj.email || "admin@gmail.com");
                setuid(obj.uid);
            } else if (
                process.env.REACT_APP_DEFAULTAUTH === "fake" ||
                process.env.REACT_APP_DEFAULTAUTH === "jwt"
            ) {
                const obj = JSON.parse(localStorage.getItem("authUser") || "");
                setUserName(obj.username);
                setemail(obj.email || "admin@gmail.com");
                setuid(obj.uid);
            }
            setTimeout(() => {
                dispatch(resetProfileFlag());
            }, 3000);
        }
    }, [dispatch, success, error]);

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            username: userName || 'Admin',
            uid: uid || '',
        },
        validationSchema: Yup.object({
            username: Yup.string().required("Please Enter Your UserName"),
        }),
        onSubmit: (values) => {
            dispatch(editProfile(values));
        }
    });
    const classes = useStyles();
    const {
        inherit,  cardBorder, cardbg  } = Colortheme();

    return (
        <React.Fragment>
            <Grid container>
                <Grid item xs={12}>
                    <Box sx={{ marginY: "1rem" }}>
                        {error && error ? <Alert severity="error">{error}</Alert> : null}
                        {success ? <Alert severity="success">Username Updated To {userName}</Alert> : null}
                    </Box>
                    <Box className={classes.cardCommam} sx={{ borderColor: cardBorder, backgroundColor: cardbg, overflow: 'hidden' }}>
                        <Box sx={{ display: "flex", alignItems: "center", padding: '16px' }}>
                            <Box sx={{ marginRight: '16px' }}>
                                <Avatar alt="avatar" src={avatar} sx={{ height: 62, width: 62 }} />
                            </Box>
                            <Box sx={{ flexGrow: 1, alignSelf: "center" }}>
                                <Box sx={{ color: "grey" }}>
                                    <Typography sx={{ fontSize: '18px', fontWeight: 500, color: theme.palette.mode === 'light' ? '#000' : '#438eff', marginBottom: '2px' }}>{userName}</Typography>
                                    <Typography sx={{ fontSize: '14px', marginBottom: '2px', color: inherit }}>Email Id :{email}</Typography>
                                    <Typography sx={{ fontSize: '14px', color: inherit }}>Id No : #{uid}</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>

            <Grid item md={12}>
                <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: 600, marginBottom: '8px', color: theme.palette.mode === 'light' ? '#000' : '#fff', margin: '16px 0' }} >Change User Name</Typography>
                <Box className={classes.cardCommam} sx={{ borderColor: cardBorder, backgroundColor: cardbg, overflow: 'hidden', padding: '16px' }}>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                    }}>
                        <Box sx={{ marginBottom: "1.5rem" }}>
                            <InputLabel htmlFor="username" >Username</InputLabel>
                            <TextField sx={{ marginTop: '12px' }} fullWidth variant="outlined" size='small' placeholder="Enter username" name="username"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.username || ""}
                                error={
                                    validation.touched.username && validation.errors.username ? true : false
                                }
                                helperText={validation.touched.username && validation.errors.username ? validation.errors.username : false}
                            />
                        </Box>
                        <Box sx={{ textAlign: "center" }}>
                            <Button variant="contained" color="error" type="submit" sx={{ color: '#fff' }}>
                                Update User Name
                            </Button>
                        </Box>
                    </form>
                </Box>
            </Grid>

        </React.Fragment >
    );
};

export default UserProfile;
